var map = {
	"./Agility_icon.webp": 4020,
	"./Attack_icon.webp": 782,
	"./Construction_icon.webp": 296,
	"./Cooking_icon.webp": 6222,
	"./Crafting_icon.webp": 4984,
	"./Defence_icon.webp": 4648,
	"./Farming_icon.webp": 6832,
	"./Firemaking_icon.webp": 3048,
	"./Fishing_icon.webp": 4472,
	"./Fletching_icon.webp": 2172,
	"./Herblore_icon.webp": 6630,
	"./Hitpoints_icon.webp": 2886,
	"./Hunter_icon.webp": 496,
	"./Magic_icon.webp": 4728,
	"./Mining_icon.webp": 5442,
	"./Overall_icon.webp": 4554,
	"./Prayer_icon.webp": 7504,
	"./Ranged_icon.webp": 2320,
	"./Runecrafting_icon.webp": 560,
	"./Slayer_icon.webp": 5492,
	"./Smithing_icon.webp": 1472,
	"./Strength_icon.webp": 7620,
	"./Thieving_icon.webp": 896,
	"./Woodcutting_icon.webp": 9384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9331;